module.exports = __webpack_public_path__ + "static/media/ziegelmauer.6f62e55b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/ziegelmauer.JPG
// module id = 781
// module chunks = 0